// src/pages/UpgradeFailed.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

export default function UpgradeFailed() {
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      px={2}
      textAlign="center"
    >
      <Typography variant="h4" gutterBottom>
        Upgrade Failed
      </Typography>
      <Typography variant="body1" color="textSecondary" gutterBottom>
        Sorry, we couldn’t complete your upgrade. Please try again or contact support if the issue persists.
      </Typography>
      <Box mt={3} display="flex" gap={2}>
        <Button
          variant="contained"
          onClick={() => navigate('/portal')}
        >
          Back to Portal
        </Button>
      </Box>
    </Box>
  );
}

